import React from 'react';
import styled from 'styled-components';

const ModalBg = styled.div`
    position: fixed;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: #0000008a;
    z-index: 1300;
    animation: modalShow .3s;
    
    @keyframes modalShow {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const ModalBackground = (props) => {
    return (
        <ModalBg onClick={props.onClick}/>
    )
}

export default ModalBackground;